import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckCircleIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { IMAGES } from '../data/content';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-cream" data-id="element-65" data-mp="9ipbb96819z2">
      {/* decorative blobs */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-green-soft/60 blur-3xl" data-id="element-66" data-mp="4jm5hmif2zq1" />
      <div className="pointer-events-none absolute -right-16 top-40 h-64 w-64 rounded-full bg-yellow-soft/70 blur-3xl" data-id="element-67" data-mp="xae7j0m5yila" />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-5 py-14 sm:py-20 lg:grid-cols-2 lg:gap-8" data-id="element-68" data-mp="sart4nulmwaw">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center lg:text-left" data-id="element-69" data-mp="nbopn7u9oy51">
          <span className="inline-flex items-center gap-2 rounded-full bg-green-soft px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-green-deep" data-id="element-70" data-mp="380vz9yqbyvdo">
            🍎 Guía digital para mamás
          </span>

          <h1 className="mt-5 font-display text-4xl font-black leading-[1.05] text-green-deep sm:text-5xl lg:text-6xl" data-id="element-71" data-mp="3o5j39ad4ljlt">
            250 recetas para viandas escolares{' '}
            <span className="text-green-brand" data-id="element-72" data-mp="3e84rho25dizu">nutritivas y ricas</span>
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-[#4A5748] lg:mx-0" data-id="element-73" data-mp="30gzu6sm952so">
            Accedé a viandas variadas y aprobadas por los chicos durante más de
            10 meses escolares. Despedite del <em data-id="element-74" data-mp="2ql68aimn7wy8">“¿qué cocino hoy?”</em>.
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row lg:items-start lg:justify-start" data-id="element-75" data-mp="2violwmblv0ck">
            <CTAButton data-id="element-76" data-mp="2hinbaf5jgejw">Quiero mi guía con 50% OFF</CTAButton>
          </div>

          {/* trust row */}
          <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-center lg:justify-start" data-id="element-77" data-mp="2ll0eowwtc0di">
            <div className="flex items-center gap-1" data-id="element-78" data-mp="s333va8e4ivy">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-yellow-brand text-yellow-brand" data-id="element-79" data-mp="n9qhz7v3iq6w" data-mpi={i} />)}
            </div>
            <span className="text-sm font-bold text-[#4A5748]" data-id="element-80" data-mp="ia5kz2zhkrwt">
              +5.718 descargas de mamás felices
            </span>
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold text-[#4A5748] lg:justify-start" data-id="element-81" data-mp="1b15q5h9k01q2">
            <span className="inline-flex items-center gap-1.5" data-id="element-82" data-mp="15zq1zgc2xf3g">
              <DownloadIcon className="h-4 w-4 text-green-brand" data-id="element-83" data-mp="111ohcqz097pv" /> Acceso inmediato
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-84" data-mp="x0cqyj8b4igm">
              <ShieldCheckIcon className="h-4 w-4 text-green-brand" data-id="element-85" data-mp="3lsp49g06snfh" /> Garantía de 7 días
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3hqu0m4us9xyj">
              <CheckCircleIcon className="h-4 w-4 text-green-brand" data-id="element-87" data-mp="3htpzpwidasok" /> Pago seguro
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} className="relative mx-auto w-full max-w-md" data-id="element-88" data-mp="21aeg18zu476x">
          <div className="absolute -right-3 -top-3 z-10 rotate-6 rounded-2xl bg-yellow-brand px-4 py-2 text-center font-display font-black leading-none text-green-deep shadow-lg" data-id="element-89" data-mp="2b2aisxcv8lhh">
            <span className="block text-2xl" data-id="element-90" data-mp="2kxudjgfp1e4n">50%</span>
            <span className="text-[10px] font-bold uppercase tracking-widest" data-id="element-91" data-mp="2p0h8hq7nvf62">OFF hoy</span>
          </div>
          <img src={IMAGES.hero} alt="Ebook de 250 recetas para viandas escolares mostrado en una tablet" className="w-full rounded-3xl object-cover shadow-2xl" data-id="element-92" data-mp="2tzljmme5bmz1" />
        </motion.div>
      </div>
    </section>;
}